import * as React from "react";
import { WrappedFieldProps, Field } from "redux-form";
import * as ReactTooltip from "react-tooltip";
import IntlTelInput from "react-intl-tel-input";
// import CountryList from "components/Forms/CountryList";
import Select from "react-select";
import "react-intl-tel-input/dist/main.css";
import countryList from "react-select-country-list";
import { countries } from "./countries";

type Props = {
  label: string;
  options?: any;
  type: string;
  disabled: boolean;
  placeholder: string;
  wrapperClassName?: string;
  rows?: number;
  isAutoComplete?: boolean;
  dataTip?: boolean;
};

type S = {
  options: any;
};

class RenderField extends React.PureComponent<WrappedFieldProps & Props, S> {
  constructor(props) {
    super(props);
    this.state = {
      options: countries,
    };
  }

  public render() {
    const {
      input,
      meta,
      label,
      type,
      disabled,
      placeholder,
      wrapperClassName,
      rows,
      dataTip = "",
    } = this.props;

    const { options } = this.state;
    let formClasses: string = "form_field";
    formClasses += meta.error && meta.touched ? " form_field--has_error" : "";
    formClasses += type ? ` form_field--${type}` : "";
    formClasses += wrapperClassName ? ` ${wrapperClassName} ` : "";
    formClasses += disabled ? " form_field--disabled" : "";
    return (
      <div className={formClasses}>
        {dataTip && (
          <ReactTooltip id={input.name} effect="solid">
            <span>{dataTip} </span>
          </ReactTooltip>
        )}
        {label && type !== "textarea" && type !== "checkbox" && (
          <label data-tip data-for={input.name} htmlFor={input.name}>
            {label}
          </label>
        )}
        {type && type === "checkbox" && (
          <div>
            <div className="checkbox__details">
              <input
                disabled={disabled || false}
                {...input}
                checked={input.value}
                id={input.name}
                value={input.value}
                type={type}
              />
              <label className="custom-box" htmlFor={input.name} />

              <label htmlFor={input.name}>{label}</label>
            </div>
            {(meta.touched && meta.error && (
              <div className="form_field--error_wrapper">
                <span className="form_field--error">{meta.error}</span>
              </div>
            )) ||
              (meta.warning && <span>{meta.warning}</span>)}
          </div>
        )}
        {type && type === "intlTelInput" && (
          <div>
            <IntlTelInput
              preferredCountries={["pl"]}
              name={input.name}
              onPhoneNumberChange={(status, value, countryData, number, id) => {
                input.onChange(value);
              }}
              onPhoneNumberBlur={(status, value, countryData, number, id) => {
                input.onBlur(input.value);
              }}
            />
            {(meta.touched && meta.error && (
              <div className="form_field--error_wrapper">
                <span className="form_field--error">{meta.error}</span>
              </div>
            )) ||
              (meta.warning && <span>{meta.warning}</span>)}
          </div>
        )}
        {type && type === "countryList" && (
          <div>
            <Select
              options={options}
              value={options.find(
                ({ label: optionLabel }) => optionLabel === input.value
              )}
              onChange={(value) => input.onChange(value.label)}
              placeholder={label}
            />
            {(meta.touched && meta.error && (
              <div className="form_field--error_wrapper">
                <span className="form_field--error">{meta.error}</span>
              </div>
            )) ||
              (meta.warning && <span>{meta.warning}</span>)}
          </div>
        )}
        {type && type == "textarea" && (
          <div>
            <textarea
              disabled={disabled || false}
              {...input}
              value={input.value}
              placeholder={placeholder ? placeholder : label}
              rows={rows}
            />
            {(meta.touched && meta.error && (
              <div className="form_field--error_wrapper">
                <span className="form_field--error">{meta.error}</span>
              </div>
            )) ||
              (meta.warning && <span>{meta.warning}</span>)}
          </div>
        )}
        {type &&
          type !== "textarea" &&
          type !== "checkbox" &&
          type !== "intlTelInput" &&
          type !== "countryList" && (
            <div>
              <input
                autoComplete={this.props.isAutoComplete ? "on" : "new-password"}
                disabled={disabled || false}
                {...input}
                value={input.value}
                placeholder={placeholder ? placeholder : label}
                type={type}
              />
              {(meta.touched && meta.error && (
                <div className="form_field--error_wrapper">
                  <span className="form_field--error">{meta.error}</span>
                </div>
              )) ||
                (meta.warning && <span>{meta.warning}</span>)}
            </div>
          )}
      </div>
    );
  }
}

export default RenderField;



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/RegularField.tsx